<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Modify Item</h4>
                <p class="text-subtitle-1"></p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-1">
            <v-col>
                <ItemForm
                    ref="form" 
                    v-model="data" 
                    v-if="!itemLoading"
                />
                <ItemFormLoader class="pa-3" v-else/>
            </v-col>
        </v-row>
        <v-row class="mt-1">
            <v-col cols="12" md="3">
                <v-btn class="primary" block @click="handleSave" v-if="this.hasPermission(this.perm.item.update)" >
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleCancel" >
                    <v-icon left>mdi-cancel</v-icon>
                    cencel
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn class="error--text" depressed block @click="handleDelete" v-if="this.hasPermission(this.perm.item.delete)" >
                    <v-icon left>mdi-delete</v-icon>
                    delete
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert'
import ItemForm from './../../components/warehouse/ItemForm';
import ItemFormLoader from './../../components/warehouse/ItemFormLoader';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "ItemEditView",
    components: {
        ItemForm,
        PAlert,
        ItemFormLoader
    },
    data() {
        return {
            id: null,
            data: null,
            itemLoading: false,
            alert: {
                title: "Alert",
                content: "Are you sure?",
                value: false,
                callback: null
            },
            loading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            findByID: "stock/item/findByID",
            update: "stock/item/update",
            remove: "stock/item/remove",
            pushGroup: "stock/itemGroup/search/push",
            pushMeasureUnit: "warehouse/measureUnit/search/push",
        
        }),
        getItem() {
            this.itemLoading = true
            this.findByID(this.id).then(response => {
                this.pushGroup(response.data.group)
                this.pushMeasureUnit(response.data.measure_unit)
                let data = {
                    ...response.data,
                    type_id: response.data.type.id,
                    group_id: response.data.group.id,
                    measure_unit_id : response.data.measure_unit.id
                }
                this.data = data
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.itemLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save(){
            this.loading = true 
            this.update(this.data).then(response => {
                this.$router.push({ name: "ItemDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Item Updated", color: "success"})
            }).catch( error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = true
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Delete?", callback: this.removeItem};
        },
        removeItem() {
            this.loading = true
            this.remove(this.data).then(() => {
                this.snackbar({color: 'success', text: "Item Deleted" })
                this.$router.push({ name: "ItemList" })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "ItemList"})
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Discard Changes?", callback: this.cancel};
        },
        cancel() {
            this.$router.back()
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getItem()
    },
    beforeRouteUpdate(to, from, next) {
        console.log('hi')
        this.id = to.params.id;
        this.getItem();
        next()
    }
}
</script>

<style>

</style>